import React from "react";
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import HomePage from "./pages/homePage/homePage";
import CommonQuestions from "./components/commonQuestions";
import NewCustomer from "./pages/newCustomer";
import ExistingCustomerMainPage from "./pages/existingCustomer/mainPage";
import NavBar from "./pages/navBar";
import Upgrade from "./pages/existingCustomer/upgrade";
import AddOn from "./pages/existingCustomer/addOn";
import NewDsmLicense from "./pages/existingCustomer/newDsmLicense";
import CCKM from "./pages/existingCustomer/cckm";
import Other from "./pages/existingCustomer/other";
import { Container, Header } from "semantic-ui-react";

const PageNotFound = () => {
  return (
    <Container>
      <Header size="large" textAlign="center">
        Page Not Found
      </Header>
    </Container>
  );
};

function App() {
  return (
    <div>
      <Router>
        <NavBar />
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/common_questions" component={CommonQuestions} />
          <Route exact path="/new_customer" component={NewCustomer} />
          <Route
            exact
            path="/existing_customer"
            component={ExistingCustomerMainPage}
          />
          <Route exact path="/existing_customer/upgrade" component={Upgrade} />
          <Route exact path="/existing_customer/addon" component={AddOn} />
          <Route
            exact
            path="/existing_customer/new_dsm_license"
            component={NewDsmLicense}
          />
          <Route exact path="/existing_customer/cckm" component={CCKM} />
          <Route exact path="/existing_customer/other" component={Other} />
          <Route exact path="*" component={PageNotFound} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
